var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"filterable":"","clearable":"","loading":_vm.isLoading,"disabled":_vm.isDisabled,"placeholder":"Ingrese una obra social"},on:{"input":_vm.onInput}},_vm._l((_vm.financiadores),function(financiador){return _c('el-option',{key:financiador,attrs:{"label":financiador,"value":financiador}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }